(function () {
  const STORAGE_KEYS = {
    converted: 'sample_popup_converted',
    dismissedAt: 'sample_popup_dismissed_at',
    sessionShown: 'sample_popup_shown',
    chatbotAppeared: 'chatbot_first_appeared_at',
  };

  const CHATBOT_COOLDOWN_MS = 90000;
  const TIME_TRIGGER_MS = 30000;
  const DISMISS_DAYS = 14;
  const MOBILE_BREAKPOINT = 749;
  const MOBILE_SCROLL_DEPTH = 0.5;
  const CHAT_HOST_SELECTORS = ['shopify-chat', 'inbox-online-store-chat'];
  const CHAT_OPEN_STATE_SELECTORS = 'button.chat-app--close-button, [role="dialog"]';

  const config = window.samplePackPopupConfig;

  if (!config || !config.enabled) return;

  const popup = document.getElementById('sample-pack-popup');
  if (!popup) return;

  const closeButtons = popup.querySelectorAll('[data-sample-pack-popup-close]');
  const ctaButton = popup.querySelector('[data-sample-pack-popup-cta]');

  let isOpen = false;
  let hasTriggered = false;
  let cartChecked = false;
  let cartHasSamplePack = false;
  const initializedAt = Date.now();

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
  }

  function safeGetItem(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeSetItem(storage, key, value) {
    try {
      storage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function safeRemoveItem(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Storage unavailable.
    }
  }

  function isPermanentlySuppressed() {
    return safeGetItem(localStorage, STORAGE_KEYS.converted) === 'true';
  }

  function isDismissedRecently() {
    const dismissedAt = safeGetItem(localStorage, STORAGE_KEYS.dismissedAt);
    if (!dismissedAt) return false;

    const elapsedDays = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
    return elapsedDays < DISMISS_DAYS;
  }

  function wasShownThisSession() {
    return safeGetItem(sessionStorage, STORAGE_KEYS.sessionShown) === 'true';
  }

  function isPopupFullySuppressed() {
    return isPermanentlySuppressed() || isDismissedRecently() || wasShownThisSession() || cartHasSamplePack;
  }

  function isChatbotCooldownActive() {
    const appearedAt = safeGetItem(sessionStorage, STORAGE_KEYS.chatbotAppeared);
    if (!appearedAt) return false;

    const elapsedMs = Date.now() - Number(appearedAt);
    if (elapsedMs >= CHATBOT_COOLDOWN_MS) {
      safeRemoveItem(sessionStorage, STORAGE_KEYS.chatbotAppeared);
      return false;
    }

    return true;
  }

  function canShowPopup() {
    if (isPopupFullySuppressed()) return false;
    if (isChatbotCooldownActive()) return false;
    return true;
  }

  function findChatHost() {
    for (let index = 0; index < CHAT_HOST_SELECTORS.length; index += 1) {
      const host = document.querySelector(CHAT_HOST_SELECTORS[index]);
      if (host) return host;
    }

    return null;
  }

  function isElementVisible(element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
  }

  function isChatOpen() {
    const host = findChatHost();
    if (!host) return false;

    if (host.hasAttribute('open') || host.getAttribute('is-open') === 'true') return true;

    const shadow = host.shadowRoot;
    if (shadow) {
      const openStateElement = shadow.querySelector(CHAT_OPEN_STATE_SELECTORS);
      if (openStateElement && isElementVisible(openStateElement)) return true;
    }

    return false;
  }

  function recordChatbotAppearance() {
    if (safeGetItem(sessionStorage, STORAGE_KEYS.chatbotAppeared)) return;

    if (safeSetItem(sessionStorage, STORAGE_KEYS.chatbotAppeared, String(Date.now()))) {
      safeRemoveItem(localStorage, STORAGE_KEYS.chatbotAppeared);
    }
  }

  function observeChatbot() {
    if (safeGetItem(sessionStorage, STORAGE_KEYS.chatbotAppeared)) return;

    let observer;
    let pollTimer;
    let stopTimer;

    function cleanup() {
      if (observer) observer.disconnect();
      if (pollTimer) window.clearInterval(pollTimer);
      if (stopTimer) window.clearTimeout(stopTimer);
    }

    function tryRecord() {
      if (!isChatOpen()) return false;

      recordChatbotAppearance();
      cleanup();
      return true;
    }

    if (tryRecord()) return;

    observer = new MutationObserver(() => {
      tryRecord();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['open', 'is-open'],
      childList: true,
      subtree: true,
    });

    pollTimer = window.setInterval(tryRecord, 500);
    stopTimer = window.setTimeout(cleanup, 120000);
  }

  function markPermanentSuppress() {
    safeSetItem(localStorage, STORAGE_KEYS.converted, 'true');
  }

  function markDismissed() {
    safeSetItem(localStorage, STORAGE_KEYS.dismissedAt, String(Date.now()));
  }

  function markShownThisSession() {
    safeSetItem(sessionStorage, STORAGE_KEYS.sessionShown, 'true');
  }

  function openPopup() {
    if (isOpen || hasTriggered || !canShowPopup()) return;

    hasTriggered = true;
    isOpen = true;
    markShownThisSession();

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });

    document.addEventListener('keydown', onEscapeKey);
  }

  function closePopup(options = {}) {
    if (!isOpen) return;

    isOpen = false;
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onEscapeKey);

    if (options.dismissed) {
      markDismissed();
    }

    window.setTimeout(() => {
      if (!isOpen) {
        popup.hidden = true;
      }
    }, 400);
  }

  function onEscapeKey(event) {
    if (event.code === 'Escape') {
      closePopup({ dismissed: true });
    }
  }

  async function checkCartForSamplePack() {
    if (cartChecked) return;
    cartChecked = true;

    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return;

      const cart = await response.json();
      const sampleVariantIds = new Set((config.samplePackVariantIds || []).map(String));

      cartHasSamplePack = (cart.items || []).some((item) => {
        return sampleVariantIds.has(String(item.variant_id)) || String(item.handle || '').includes('sample-pack');
      });
    } catch (error) {
      console.error('Sample pack popup cart check failed', error);
    }
  }

  async function handleCtaClick() {
    if (!ctaButton || ctaButton.disabled) return;

    ctaButton.disabled = true;

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: config.variantId, quantity: 1 }],
        }),
      });

      const addResult = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(addResult.description || addResult.message || 'Unable to add sample pack to cart.');
      }

      closePopup();
      markPermanentSuppress();

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            popup_source: 'sample_popup',
          },
        }),
      });

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(addResult);
        return;
      }

      window.location.href = config.cartUrl || window.routes?.cart_url || '/cart';
    } catch (error) {
      console.error('Sample pack popup add to cart failed', error);
      ctaButton.disabled = false;
    }
  }

  function setupExitIntent() {
    if (isMobile()) return;

    document.documentElement.addEventListener('mouseout', (event) => {
      if (hasTriggered || !canShowPopup()) return;
      if (event.relatedTarget || event.clientY > 0) return;

      openPopup();
    });
  }

  function setupMobileScrollTrigger() {
    if (!isMobile()) return;

    function onScroll() {
      if (hasTriggered || !canShowPopup()) return;

      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;

      const scrollTop = window.scrollY || window.pageYOffset || 0;
      if (scrollTop / scrollableHeight < MOBILE_SCROLL_DEPTH) return;

      window.removeEventListener('scroll', onScroll);
      openPopup();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function scheduleShowWhenEligible() {
    if (hasTriggered || !canShowPopup()) {
      if (!hasTriggered && isChatbotCooldownActive()) {
        const appearedAt = Number(safeGetItem(sessionStorage, STORAGE_KEYS.chatbotAppeared) || Date.now());
        const retryIn = Math.max(CHATBOT_COOLDOWN_MS - (Date.now() - appearedAt), 0) + 50;

        window.setTimeout(() => {
          if (!hasTriggered && canShowPopup()) {
            openPopup();
          }
        }, retryIn);
      }

      return;
    }

    openPopup();
  }

  function setupTimeTrigger() {
    const remainingMs = Math.max(TIME_TRIGGER_MS - (Date.now() - initializedAt), 0);

    window.setTimeout(() => {
      if (!hasTriggered) {
        scheduleShowWhenEligible();
      }
    }, remainingMs);
  }

  async function init() {
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closePopup({ dismissed: true });
      });
    });

    if (ctaButton) {
      ctaButton.addEventListener('click', handleCtaClick);
    }

    if (isPopupFullySuppressed()) return;

    safeRemoveItem(localStorage, STORAGE_KEYS.chatbotAppeared);
    observeChatbot();
    await checkCartForSamplePack();

    if (isPopupFullySuppressed()) return;

    setupExitIntent();
    setupMobileScrollTrigger();
    setupTimeTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
